/**
 * SnapFind Cart Module
 * Handles AJAX add-to-cart functionality for any element with [data-snaf-cart].
 *
 * @since 1.0.0
 */

export function initCart() {
    // We use a delegated listener to catch clicks on any [data-snaf-cart] element,
    // including those rendered dynamically by InstantSearch.
    document.addEventListener('click', async (e) => {
        const target = e.target.closest('[data-snaf-cart]');
        if (!target) return;

        e.preventDefault();

        const productId = target.getAttribute('data-snaf-cart');
        if (!productId) return;

        // Prevent multiple simultaneous clicks
        if (target.dataset.snafState === 'adding') return;

        // Store original text to revert back later
        const originalText = target.innerText;
        target.dataset.snafState = 'adding';
        target.innerText = 'Adding...';

        try {
            const formData = new FormData();
            formData.append('product_id', productId);
            formData.append('quantity', 1);

            // Using WooCommerce standard AJAX add-to-cart endpoint
            const response = await fetch('/?wc-ajax=add_to_cart', {
                method: 'POST',
                body: formData,
                headers: {
                    Accept: 'application/json',
                },
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json();

            if (data.error && data.product_url) {
                // If there's an error (e.g. variable product), redirect to product page
                window.location.href = data.product_url;
                return;
            }

            // Success state
            target.innerText = 'Added';
            target.dataset.snafState = 'added';

            // Compatibility: Trigger standard WooCommerce event for themes/mini-carts
            if (window.jQuery) {
                window
                    .jQuery(document.body)
                    .trigger('added_to_cart', [
                        data.fragments,
                        data.cart_hash,
                        window.jQuery(target),
                    ]);
            }

            // Cleanup: WooCommerce/Themes often inject a "View cart" link after the button.
            setTimeout(() => {
                const parent = target.parentElement;
                if (parent) {
                    // Check for common WC classes or the specific title (case-insensitive)
                    const links = parent.querySelectorAll(
                        '.added_to_cart, .wc-forward, [title*="view cart" i], [title*="View cart"]'
                    );
                    links.forEach((link) => link.remove());
                }
            }, 100);

            // Revert back to original text after 3 seconds
            setTimeout(() => {
                target.innerText = originalText;
                delete target.dataset.snafState;
            }, 3000);
        } catch (error) {
            console.error('SnapFind Add to Cart Error:', error);
            target.innerText = 'Error';

            setTimeout(() => {
                target.innerText = originalText;
                delete target.dataset.snafState;
            }, 3000);
        }
    });
}
